const forms = {
  onRequest: "要求に応じて", // translated
  person: "人", // translated
  travelDate: "旅行日", // translated
  travelDates: "旅行日程", // translated
  cancel: "キャンセル", // translated
  getPrice: "価格を取得", // translated
};


export default forms;
